const state = {
  identity: localStorage.getItem('identity')
}

const getters = {
  identity (state) {
    return state.identity
  }
}

const mutations = {
  SET_IDENTITY (state, identity) {
    state.identity = identity
  }
}

const actions = {
  setIdentity ({ commit }, identity) {
    localStorage.setItem('identity', identity)
    commit('SET_IDENTITY', identity)
  },
  removeIdentity ({ commit }) {
    localStorage.removeItem('identity')
    commit('SET_IDENTITY', null)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
